<template>
  <v-card>

      <v-toolbar dark color="primary">
        <v-toolbar-title>Import User</v-toolbar-title>
        <slot name="header"></slot>
      </v-toolbar>


    <v-card-title>
    <search v-model="search" />
    </v-card-title>

    <v-data-table
      :items="users"
      :items-per-page="options.itemsPerPage"
      :headers="headers"
      :loading="$wait.is(['loading entra users'])"
      :footer-props.sync="footerProps"
      :options.sync="options"
    >
      <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
      <template v-slot:item="props">
        <tr @click="userIsFleetManager ? importUser(props.item) : null">
          <td>{{props.item.employeeNumber}}</td>
          <td>{{props.item.displayName}}</td>
          <td>{{props.item.mail}}</td>
          <td>{{props.item.department}}</td>
          <td></td>
          <td width="76px" class="pl-0" v-if="userIsFleetManager">
            <v-btn @click="importUser(props.item)" icon>
              <v-icon>add</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
      <template v-slot:no-results>
        <v-layout row align-center>
          <v-flex>No matching records found</v-flex>
        </v-layout>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { VclList } from 'vue-content-loading';
import Users from './UsersClient.vue';
import FormValidation from '../FormValidation.vue';
import Search from '@/components/Search.vue';

export default {
  components: {
    Search,
    VclList,
  },
  mixins: [
    FormValidation,
    Users
  ],
  data() {
    return {
      users: [],
      search: '',
      options: {
        itemsPerPage: 10,
        sortBy: ['displayName']
      },
      footerProps: {
        itemsPerPageOptions: [10, 50, 100]
      },
      headers: [
        { text: 'Employee Number', value: 'employeeNumber' },
        { text: 'Name', value: 'displayName' },
        { text: 'Email', value: 'mail' },
        { text: 'Department', value: 'department' },
        {}
      ]
    };
  },
  methods: {
    submitForm() {
      this.submitted = true;
      this.import();
    },
    importUser(user) {
      this.$emit('import', { value: user });
    },
  },
  watch: {
    value() {
      this.submitted = false;
    },
    async search(value) {
      if (value.length < 3) {
          return;
      }
      this.users = await this.getEntraUsers(value);
    }
  },
  async mounted() {
    await this.getGarageSelections();
  }
};
</script>
